export default __webpack_public_path__ + "images/Sagittal_View_for_CRL_and_NC_Measurements.d9746b3e41343c83cc400bc077c899e1.png";